<template>
  <div class="wallet-navigation">
    <v-btn
      class="wallet-navigation-button"
      @click="$emit('back')"
      >
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    <!-- <v-btn
      @click="$emit('today')"
      >
      {{today_disabled?'start':'today'}}
    </v-btn> -->
    <!-- date picker -->
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" v-bind="attrs">
          <v-icon>today</v-icon>
        </v-btn>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        :locale-first-day-of-year="4"
        scrollable
        color="blue lighten-1"
        >
        <v-btn
          v-if="!today_disabled"
          text
          @click="date = new Date().toISOString().substr(0, 10)"
          >
          {{$t('AppLayout.NavBar.Project.TaktWallet.Today')}}
        </v-btn>
        <v-btn
          text
          @click="date = project_start.substr(0, 10)"
          >
          {{$t('AppLayout.NavBar.Project.TaktWallet.Start')}}
        </v-btn>
        <v-spacer/>
        <v-btn
          text
          @click="$emit('selectDate', date), menu = false"
          >
          {{$t('Buttons.Ok')}}
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-btn
      class="wallet-navigation-button"
      @click="$emit('foreward')"
      >
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
</template>
<script>
  export default {
    props:['today_disabled', 'project_start', 'selected_date'],
    data: () => ({
      menu: false,
      date: new Date().toISOString().substr(0, 10),
    }),
    mounted() {
      this.date = this.selected_date.toISOString().substr(0, 10)
    },
    watch: {
      selected_date() {
        this.date = this.selected_date.toISOString().substr(0, 10)
      },
      menu(val) {
        if (val) {
          this.date = this.selected_date.toISOString().substr(0, 10)
        }
      }
    }
  }
</script>
<style>
  .wallet-navigation {
    display: flex;
  }
  .wallet-navigation-button {
    min-width: 0px !important;
    padding: 10px !important;
  }
</style>
